/**
 * useSessionStorage
 * sessionStorageはこのHookを使ってアクセスする。
 * 新たに項目を増やす場合は
 * 1. `StorageKeys` にストレージのキーを追加
 * 2. createStorageHook のジェネリクス引数に期待する返り値の型を追加
 * 3. createStorageHook の引数にデフォルト（フォールバック）値を追加
 */
import { createStorageHook } from '~/lib/createStorageHook'
import { isBrowser } from '~/lib/isBrowser'

export type StorageKeys =
  | 'hide_coordinate_detail_imagesearch_tutorial'
  | 'showed_app_redirect_half_modal_on_member_detail'
  | 'showed_app_redirect_half_modal_on_item_detail'
  | 'status_of_app_redirect_half_modal_on_coordinate_list'
  | 'view_count_app_redirect_half_modal_on_coordinate_detail'
  | 'view_count_app_redirect_half_modal_on_video_detail'
  | 'coordinate_list_banner_closed'

const storage = isBrowser ? window.sessionStorage : undefined

export const useSessionStorage = createStorageHook<
  StorageKeys,
  {
    hide_coordinate_detail_imagesearch_tutorial: boolean
    showed_app_redirect_half_modal_on_member_detail: boolean
    showed_app_redirect_half_modal_on_item_detail: boolean
    status_of_app_redirect_half_modal_on_coordinate_list: {
      displayed: boolean
      pageViewCount: number
    }
    view_count_app_redirect_half_modal_on_coordinate_detail: number
    view_count_app_redirect_half_modal_on_video_detail: number
    coordinate_list_banner_closed: boolean
  }
>(storage, {
  hide_coordinate_detail_imagesearch_tutorial: false,
  showed_app_redirect_half_modal_on_member_detail: false,
  showed_app_redirect_half_modal_on_item_detail: false,
  status_of_app_redirect_half_modal_on_coordinate_list: {
    displayed: false,
    pageViewCount: 0,
  },
  view_count_app_redirect_half_modal_on_coordinate_detail: 0,
  view_count_app_redirect_half_modal_on_video_detail: 0,
  coordinate_list_banner_closed: false,
})
